"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const BehaviorSubject_1 = require("rxjs/BehaviorSubject");
let InaxConfiguration = InaxConfiguration_1 = class InaxConfiguration {
    /* would be nice, but leads to cyclic dependencies, since each HubService wants an injection of this config. kgo, 22.12.16
    constructor(@Inject(IHUBSERVICE_TOKEN) private _hubServices: IHubService[]) {
        this._hubServices.forEach(service => {
            if (service) {
                this.SignalRHubs.push(service.hubName);
            }
        })
        this.loadConfiguration();
    }
    */
    constructor() {
        this.Url = "http://192.168.0.148:8099/"; // "http://localhost:8090/";
        this.Username = "";
        this.Password = "";
        this.DefaultLanguage = "DE-de";
        this.SignalRHubs = ["PlcHub", "ScriptHub", "AlarmHub"];
        this.UseSignalR = true;
        this._apiUrl = "api/";
        this._signalRUrl = "signalr";
        this.loadConfiguration();
    }
    get ServerWithApiUrl() { return this.Url + this._apiUrl; }
    get ServerWithSignalRUrl() { return this.Url + this._signalRUrl; }
    loadConfiguration() {
        let conf = localStorage.getItem('inax_configuration');
        if (conf) {
            Object.assign(this, JSON.parse(conf));
        }
        else {
            this.EnabledSignalRHubs = this.SignalRHubs.slice();
        }
        this._configurationSubject = new BehaviorSubject_1.BehaviorSubject(this);
    }
    saveConfiguration(plainConfig) {
        localStorage.setItem('inax_configuration', JSON.stringify(plainConfig));
    }
    setConfiguration(configuration) {
        Object.assign(this, configuration);
        this.saveConfiguration(configuration);
        this._configurationSubject.next(this);
    }
    getConfiguration() {
        return this._configurationSubject;
    }
    buildRestUrl(controller, methodName = "") {
        return InaxConfiguration_1.accessUrl(this.ServerWithApiUrl, controller, methodName);
    }
    buildSignalRUrl(hubname) {
        return InaxConfiguration_1.accessUrl(this._signalRUrl, hubname);
    }
    static accessUrl(server, controller, methodName = "") {
        let normalizedCommand = InaxConfiguration_1.normalize(methodName);
        let result = `${InaxConfiguration_1.normalize(server)}/${InaxConfiguration_1.normalize(controller)}`;
        if (normalizedCommand != null && normalizedCommand.length > 0)
            result += `/${normalizedCommand}`;
        return result;
    }
    static normalize(pathPart) {
        let offset = 0;
        let length = pathPart.length;
        if (pathPart.startsWith('/')) {
            offset++;
            length--;
        }
        if (pathPart.endsWith('/'))
            length--;
        return pathPart.substring(offset, offset + length);
    }
};
InaxConfiguration = InaxConfiguration_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], InaxConfiguration);
exports.InaxConfiguration = InaxConfiguration;
var InaxConfiguration_1;
